/// <reference path="../bower_components/jquery/dist/jquery.js" />
/// <reference path="../bower_components/slick-carousel/slick/slick.js" />

function initializePiranhaElements() {
    if ($('.piranha-carousel').length > 0) {
        var $piranhaCarousel = $('.piranha-carousel');
        $piranhaCarousel.on('init', function(event, slick) {
            $('[data-toggle="tooltip"]').tooltip();
        });
        $piranhaCarousel.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            arrows: true,
            lazyLoad: 'progressive',
            adaptiveHeight: false,
            prevArrow: '<button type="button" class="slick-prev" data-toggle="tooltip" data-placement="right" title="Previous"><svg class="svg svg-icon-arrow-left"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next" data-toggle="tooltip" data-placement="left" title="Next"><svg class="svg svg-icon-arrow-right"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-right"></use></svg></button>'
        });
    }
    createMarketoForm('.marketo-form-btn');
    createFormStack('.formstack-form-btn');
    initializeCollapseMenu();
}

function initializeCollapseMenu() {
    if ($('#gallerySub').length > 0) {
        $('ul.menu').find('ul').addClass('nav nav-second-level');
        $('li.has-child > a').append('<span class="caret"></span>');
        $('ul.menu').addClass('nav metismenu').metisMenu();
    }
}

function createMarketoForm(elements) {
    $(elements).each(function() {
        var $this = $(this),
        marketoFormID = $this.data('marketo-id'),
        modalTitle = $this.data('marketo-title');

        $this.attr('href', '#marketo-modal-' + marketoFormID);

        $('body').append('<div class="modal fade" tabindex="-1" role="dialog" id="marketo-modal-' + marketoFormID + '">' +
            '<div class="modal-dialog">' +
                '<div class="modal-content">' +
                    '<div class="modal-header">' +
                        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                        '<h4 class="modal-title">' + modalTitle + '</h4>' +
                    '</div>' +
                    '<div class="modal-body">' +
                        '<form id="mktoForm_' + marketoFormID  + '"></form>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>');

        $.cachedScript('//app-sn01.marketo.com/js/forms2/js/forms2.min.js').done(function(script) {
            MktoForms2.loadForm("//app-sn01.marketo.com", "530-IIW-969", marketoFormID, function (form){
                $('.mktoButton').addClass('btn btn-primary btn-outline btn-block').removeClass('mktoButton');
                $('.mktoFieldWrap').addClass('form-group').removeClass('mktoFieldWrap');
                $('.mktoField').not('input[type="checkbox"], input[type="radio"]').addClass('form-control').removeClass('mktoField');
                $('.mktoTextField').addClass('force-full-width').removeClass('mktoTextField');
                $('.mktoEmailField').addClass('force-full-width').removeClass('mktoEmailField');
                $('.mktoErrorMsg').addClass('text-info');
                $('.mktoForm').addClass('force-full-width').removeClass('mktoForm');
                $('.mktoLabel').addClass('force-full-width').removeClass('mktoLabel');
                $('.mktoHasWidth').removeClass('mktoHasWidth');
                $('.mktoButtonRow').removeClass('mktoButtonRow');
                $('.mktoCheckboxList > label').addClass('m-l-xs').after('<br>'); 
                $('.mktoGutter, .mktoAsterix').remove();
                form.onSubmit(function(values, followUpUrl) {
                    $('#marketo-modal-' + marketoFormID ).modal('hide');
                    swal({
                        title: 'Message sent',
                        text: 'Thank you! Your message has been sent.',        
                        confirmButtonText: 'Ok',
                        confirmButtonClass: 'btn-info btn-outline',
                        type: 'success',
                        timer: 15000,
                        html: true
                    });
                });
            });
        });
    });
}
function createFormStack(elements) {
    $(elements).each(function() {
        var $this = $(this),
        formstackFormID = $this.data('formstack-id'),
        modalTitle = $this.data('formstack-title');

        $this.attr('href', '#formstack-modal-' + formstackFormID);

        $('body').append('<div class="modal fade" tabindex="-1" role="dialog" id="formstack-modal-' + formstackFormID + '">' +
            '<div class="modal-dialog">' +
                '<div class="modal-content">' +
                    '<div class="modal-header">' +
                        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                        '<h4 class="modal-title">' + modalTitle + '</h4>' +
                    '</div>' +
                    '<div class="modal-body">' +
                        '<iframe src="https://bayleys.formstack.com/forms/' + formstackFormID  + '" title="' + modalTitle + '" class="form-stack" frameborder="0" style="width:100%;min-height:90vh"></iframe>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>');
    });
}